import type {EmbedProps} from '@interfaces/Embed';
import type {Language} from '@interfaces/i18n';
import {EmbedType} from '@constants/embedType';

const url = new URL((document.currentScript as HTMLScriptElement).src);
const urlParams = new URLSearchParams(url.searchParams);
const flatParamsSchemas: Partial<Record<EmbedType, Record<string, RegExp>>> = {
    [EmbedType.Tour]: {
        tourId: /^\d+$/,
    },
};

function getParam(urlSearchParams: URLSearchParams, paramName: string): string {
    if (!urlSearchParams.has(paramName)) {
        throw new Error(`${paramName} is not set`);
    }

    return urlSearchParams.get(paramName)!;
}

export function getLanguage(): Language {
    try {
        return getParam(urlParams, 'lang') as Language;
    } catch (err) {
        console.warn(err);
        return 'ru';
    }
}

export function getEmbedParams(): EmbedProps {
    // Legacy: base64-encoded JSON in `params`
    if (urlParams.has('params')) {
        try {
            return JSON.parse(decodeURIComponent(atob(getParam(urlParams, 'params')))) as EmbedProps;
        } catch (err) {
            console.warn(err);
            return {};
        }
    }

    // New: read only the params explicitly allowed for the current embed type.
    const schema = flatParamsSchemas[getEmbedType()];
    if (!schema) {
        console.warn(`Embed type "${getEmbedType()}" does not support URL params`);
        return {};
    }

    const result: Record<string, unknown> = {};
    for (const [key, pattern] of Object.entries(schema)) {
        const value = urlParams.get(key);
        if (value !== null && pattern.test(value)) {result[key] = value;}
    }
    return result as EmbedProps;
}

export function getContainerId(): string {
    return getParam(urlParams, 'container_id');
}

export function getEmbedType(): EmbedType {
    return getParam(urlParams, 'type') as EmbedType;
}

export function getToken(): string {
    return getParam(urlParams, 'token');
}
